import React, { Component } from 'react';
// import './ActionItem.pcss'
interface IProps {
    actionLabel : string,
    actionValue : string,
    actionType?: string,
    handleSubmit,
    handleQuickLinkSubmit?,
    listElemClass?,
    onClick ?,

};

interface IState { 
    null
};

let suggestionsList = ["SUGGESTION_TYPE_1" , "SUGGESTION_TYPE_2" ]

class ActionItem extends Component<IProps, IState> {

     
    render() {
        if(this.props.hasOwnProperty('actionType') && this.props.actionType === "menu"){
            return (
                <div onClick={this.props.onClick} id={"ql_"+this.props.actionLabel} className={`quickLink-action-elem`}>
                        {this.props.actionLabel}
                </div> 
            )
        }
        if(this.props.hasOwnProperty('actionType') && this.props.actionType === "outboundLink"){
            return (
                // <div className={`action-elem`}>
                    <a className="action-elem action-elem-link" href={this.props.actionValue} target="_blank" rel="noopener noreferrer">
                        {this.props.actionLabel}
                    </a>
                // </div>
            )
        }
         if(this.props.hasOwnProperty('actionType') && this.props.actionType === "initialQuicklink"){
       
            return ( 
                <div className={`quickLink-action-elem ${this.props.listElemClass || ''}`}
                 onClick={this.props.actionLabel=="Open Fixed Deposit Now!"?
                 this.props.handleSubmit.bind(this,this.props.actionValue,false,'quicklink'):
                 this.props.handleQuickLinkSubmit.bind(this,this.props.actionValue,this.props.actionLabel,'quicklink')
                
                }
                >
                {this.props.actionLabel}
                </div>
            )
        }

        if(this.props.hasOwnProperty('actionType') && this.props.actionType === "quicklink"){
       
            return (
                <div className={`quickLink-action-elem ${this.props.listElemClass || ''}`}
                onClick={this.props.handleSubmit.bind(this,this.props.actionValue)}
                >
                {this.props.actionLabel}
                </div>
            )
        }



        return (
            //add custom type for this to track external links (Lead Gen)
            typeof this.props.actionType != "undefined" ?
                    this.props.actionType.toLowerCase() == "typeint" ?
                        <>
                        {this.props.actionLabel.indexOf("MULTICHOICELINK")>-1?
                             <div><a target='_blank' href={this.props.actionLabel.split("MULTICHOICELINK")[1]} className="action-elem">{this.props.actionLabel.split("MULTICHOICELINK")[0]}</a></div>
                        :
                        this.props.actionLabel.indexOf("WFTRIGGER") > -1 ?
                            <div className="action-elem"
                                onClick={this.props.handleSubmit.bind(this,
                                this.props.actionLabel.split("WFTRIGGER")[1].trim(),
                                false,
                                this.props.actionType
                                )}>
                                {this.props.actionLabel.split("WFTRIGGER")[0].trim()}
                            </div>
                        :<div className="action-elem" onClick={this.props.handleSubmit.bind(this,this.props.actionValue,false,this.props.actionType)}>
                          {this.props.actionLabel}
                          </div>

                        }
                      
                        </>
                       
                    :
                    (this.props.actionType.toLowerCase() == "quicklink" || 
                        this.props.actionType.toLowerCase() == "disamb" || suggestionsList.indexOf(this.props.actionType) > -1 )?
                        <div className="action-elem disamb" onClick={this.props.handleSubmit.bind(this,this.props.actionValue,false,this.props.actionType)}>
                            {this.props.actionLabel}
                        </div>
                        :
                      <a className='action-elem-ext' target="_blank" href={this.props.actionValue}>{this.props.actionLabel}</a>

            :
         
            <div className={`action-elem ${this.props.listElemClass || ''}`}
            onClick={this.props.handleSubmit.bind(this,this.props.actionValue)}
            >
            {this.props.actionLabel}
            </div>

        );
    }
}

export default ActionItem;
